/**
 * description:
 * dateTime: 2024/8/20-下午5:51
 * author: ZhangJun 1580043700@qq.com
 */
import {SDrawer, SGeneralForms} from "shj-components";
import {Form} from "antd";
import {useEffect} from "react";
import {IConfig} from "shj-components/dist/es/SGeneralForms/type";
import {useRequest} from "ahooks";
import {queryMemberEventList, saveOrUpdateTask} from "@/services/member.ts";

function EditContent(props) {

    const [form] = Form.useForm();
    const {loading, runAsync} = useRequest(saveOrUpdateTask, {manual: true});
    const typeValue = Form.useWatch('type', form);

    const {data: memberEventList} = useRequest(queryMemberEventList, {defaultParams: [{state: true}]});

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue(props.data);
    }, [props.data])

    const onSubmit = () => {
        form.validateFields().then(values => {
            runAsync({
                ...props.data,
                ...values,
                name: (props.typeList || []).find(item => item.value === values.type)?.label
            }).then(() => {
                props.destroy(true)
            })
        })
    }

    const configs: Array<IConfig> = [
        {
            title: '任务配置',
            formItem: [
                {
                    label: '任务标题',
                    name: 'title',
                    required: true,
                    spanCol: 24,
                    maxLength: 10
                },
                {
                    label: '任务类型',
                    name: 'type',
                    required: true,
                    type: 'select',
                    spanCol: 24,
                    comConfig: {
                        options: props.typeList,
                        disabled: !!props.data
                    }
                },
                {
                    label: '按钮文字',
                    name: 'buttonText',
                    spanCol: 24
                },
                {
                    label: '跳转链接',
                    name: 'link',
                    // type: 'select',
                    spanCol: 24
                },
                {
                    label: '关联事件库',
                    name: 'memberEventId',
                    type: 'select',
                    required: true,
                    spanCol: 24,
                    comConfig: {
                        options: memberEventList,
                        fieldNames: {label: 'name', value: 'id'},
                        disabled: !!props.data
                    }
                },
                {
                    label: '每日次数',
                    name: 'dayTimes',
                    type: 'inputNumber',
                    required: typeValue !== 'newbie',
                    spanCol: 24,
                },
                {
                    label: '每月次数',
                    name: 'monthTimes',
                    type: 'inputNumber',
                    spanCol: 24,
                    comConfig: {
                        min: 0,
                        precision: 0
                    }
                },
                {
                    label: '排序',
                    name: 'orderSeq',
                    required: true,
                    type: 'inputNumber',
                    spanCol: 24,
                    comConfig: {
                        min: 0,
                        precision: 0
                    }
                },
                {
                    label: '状态',
                    name: 'state',
                    type: 'switch',
                    spanCol: 24
                },
                {
                    label: '任务描述',
                    name: 'description',
                    type: 'textarea',
                    maxLength: 100,
                    spanCol: 24
                }
            ]
        }
    ]

    return (
        <SDrawer open={props.open} title={props.data ? '编辑' : '新增'} onSubmit={onSubmit} width={500}
                 onCancel={() => props.destroy(false)} loading={loading}>
            <SGeneralForms layout='vertical' formConfig={{form}} configs={configs}></SGeneralForms>
        </SDrawer>
    )
}

export default EditContent;
